<template>
  <el-select v-model="id" :size="size" :clearable="clearable" :disabled="disabled" :multiple="multiple" :filterable="true" :remote="true" placeholder="输入名称搜索" :remote-method="remoteMethod" :loading="loading" @change="selectChange">
    <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item.id">
      <span>{{ item.name }}</span>
    </el-option>
  </el-select>
</template>
<script>
export default {
  props: {
    value: "",
    clearable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "small",
    },
    defaults: {
      type: Array,
      default: () => { return [] }
    },
  },
  data() {
    return {
      list: [],
      id: "",
      loading: false,
      pageType: "1",
    }
  },
  created() {
    this.id = this.value;
  },
  mounted() {
    this.remoteMethod("");
  },
  watch: {
    value: function (newValue) {
      this.id = newValue;
    },
    defaults() {
      this.setDatas();
    },
  },
  methods: {
    remoteMethod(query) {
      let params = {
        "sourceType": 1,
        "name": query,
        "pageIndex": 1,
        "pageSize": 50,
        "testPaperGroupId": [],
        "orderByType":"desc",
      }
      let url = "/api/TestPaper/GetTestPapersByUsers";
      let method = "get";
      if (this.pageType == "2") {
        url = "/api/TestPaper/GetTestPapersByTeacher";
        method = "post";
      }
      this.list = [];
      this.loading = true;
      this.https(method, url, params).then(res => {
        this.loading = false;
        this.list = res.response.data || [];
        this.setDatas();
      }).catch(res => {
        this.loading = false;
      })
    },
    selectChange(val) {
      this.$emit('input', val);
      if (!this.multiple) {
        let obj = this.list.find(item => val == item.id);
        this.$emit('change', obj);
      } else {
        let list = this.list.filter(item => val.indexOf(item.id) >= 0);
        this.$emit('change', list);
      }
    },
    setDatas() {
      this.defaults.map(item => {
        let index = this.list.findIndex(list => list.id == item.id);
        if (index < 0) {
          this.list.push(item);
        }
      })
    }
  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/pages/pc/components/shared/PaperList.vue